/**
 * @file home
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Carousel, WingBlank} from 'antd-mobile';
import {fetchCmsapiHomepage, fetchArticleList} from '../../actions/homeAction';
import ListPro from '../../components/ListPro';

import './index.less';

class Home extends Component {
    static propTypes = {
        fetchCmsapiHomepage: PropTypes.func,
        fetchArticleList: PropTypes.func,
        cmsapiHomepagea: PropTypes.object,
        articleList: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            spuSkill0: true,
            planOff: false
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            const search = location.search || '';
            location.href = '/' + search;
        }
    }

    preventDefault(e) {
        e.preventDefault();
    }

    componentDidMount() {
        this.props.fetchCmsapiHomepage();
        this.props.fetchArticleList();

        if (this.isIos()) {
            this.banner.addEventListener('touchmove', this.preventDefault, false);
        }
    }

    componentWillUnmount() {
        if (this.isIos()) {
            this.banner.removeEventListener('touchmove', this.preventDefault, false);
        }
    }

    getUrl(item) {
        if (item.banner_type === '2') {
            return item.next_url;
        }

        if (item.next_url === 'pages/brand.html') {
            return 'brand';
        }

        return `/m/product/${item.next_url}`;
    }

    isWeiXin = () => { // 判断是否是微信浏览器的函数
        let ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('micromessenger') !== -1;
    };

    render() {
        const {cmsapiHomepagea, articleList} = this.props;
        let planOff = this.state.planOff;
        let banner = [];
        let planList = [];
        let navData = [];

        if (!this.isEmptyobj(cmsapiHomepagea)) {
            banner = cmsapiHomepagea.itemlist.banner;
            planList = cmsapiHomepagea.itemlist.recommend_solution;
            navData = cmsapiHomepagea.itemlist.recommend_product;
        }
        return (
            <div className={'home'}>
                <div className={'spu-banner'} ref={banner => this.banner = banner}>
                    {
                        banner.length
                            ? <WingBlank>
                                <Carousel
                                    autoplay={false}
                                    autoplayInterval={4000}
                                    infinite
                                >
                                    {banner.map((item, index) => (
                                        <a
                                            onClick={e => {
                                                if ((item.next_url
                                                    && item.next_url.indexOf('.apk')
                                                    !== -1
                                                    && this.isWeiXin())
                                                    || !item.next_url || item.next_url === '0') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            key={index}
                                            href={this.getUrl(item)}
                                            style={{minHeight: '6.3rem'}}
                                            className={item.banner_type === '1' ? '' : 'activity'}
                                        >
                                            <div
                                                className={'banner-shade'}
                                                style={{
                                                    backgroundImage: `url(${item.mobile_background_pic})`
                                                }}
                                            >
                                                {
                                                    item.banner_type === '1'
                                                        ? <img src={item.mobile_icon} alt={item.title}/>
                                                        : <div className={'bn-img'}/>
                                                }
                                                {
                                                    item.banner_type !== '2'
                                                        ? <span>{item.note}</span>
                                                        : null
                                                }
                                            </div>
                                        </a>
                                    ))}
                                </Carousel>
                            </WingBlank>
                            : ''
                    }
                </div>
                <div className={'spu-trait mui-flex'}>
                    {!this.isEmptyobj(cmsapiHomepagea)
                        ? cmsapiHomepagea.itemlist.brand_story.map((item, index) => {
                            return <a href={item.next_url} className={'spu-trait-item'} key={index}>
                                <div className={'spu-trait-mod'}>
                                    <div className={'spu-trait-title'}>{item.title}</div>
                                    <div className={'spu-trait-des'}>{item.note}</div>
                                </div>
                            </a>;
                        })
                        : null
                    }
                </div>
                <div className={'spu-skill'}>
                    <div className={'spu-skill-title'}>
                        专业安全团队为您打造下一代智能安全产品
                    </div>
                    <div className={'spu-skill-hint'}>
                        从行为到情报，让威胁提前感知 从单点到全局，让防御滴水不漏
                        从发现到定位，让黑客无处遁形 从被动到主动，让响应反客为主
                    </div>
                    <div className={'spu-skill-list'}>
                        {navData.length
                            ? navData.map((item, index) => {
                                return <div
                                    className={this.state[`spuSkill${index}`] ? 'spu-skill-box on' : 'spu-skill-box'}
                                    key={index}>
                                    <h3
                                        onClick={() => {
                                            this.setState({
                                                [`spuSkill${index}`]: !this.state[`spuSkill${index}`]
                                            });
                                        }}
                                    >
                                        <div
                                            className={'skill-box-icon'}
                                            style={{
                                                backgroundImage: `url(${item.mobile_navigation_icon})`
                                            }}
                                        />
                                        <div className={'skill-box-name'}>{item.navigation_name}</div>
                                        <div className={'skill-box-more'}></div>
                                    </h3>
                                    {this.state[`spuSkill${index}`]
                                        ? <div
                                            className={'skill-box-link'}
                                            style={{backgroundImage: `url(${item.m_nav_bg_pic})`}}
                                        >
                                            {item.child.map((item2, index2) => {
                                                return <a href={`/m/product/${item2.alias}`} key={index2}>
                                                    <div className="skill-link-title">
                                                        <span style={{marginRight: '.24rem'}}>
                                                            {item2.navigation_name}
                                                        </span>
                                                        {item2.product_sort !== '0' && <div className="hot icon"></div>}
                                                        {item2.is_sale === '1'
                                                        && <div className="sale icon"></div>}
                                                    </div>
                                                    <div className={'skill-link-text'}>
                                                        {item2.yijuhua}
                                                    </div>
                                                </a>;
                                            })}
                                        </div>
                                        : null
                                    }
                                </div>;
                            })
                            : null
                        }
                    </div>
                </div>
                <div className={'spu-plan'}>
                    <div className={'spu-plan-title'}>企业级大数据 行业专业解决方案</div>
                    <div className={'spu-plan-des'}>
                        数十载安全数据积累 + 数十万企业安全实践<br/>
                        配合全网威胁情报协同联动<br/>
                        铸就更加智能、成熟的行业安全解决方案
                    </div>
                    <div className={'spu-plan-list'}>
                        {planList.length > 0
                            ? planList.map((item, index) => {
                                const homeRecommend = item.home_recommend;
                                if (index > 4 && !planOff) {
                                    return null;
                                }
                                return <a
                                    href={`/m/product/${item.alias}`}
                                    className={'plan-list-cell pr'} key={index}
                                >
                                    <img
                                        src={homeRecommend && homeRecommend.mobilePic}
                                        alt={item.navigation_name}
                                        width={'100%'}
                                    />
                                    <div className={'list-cell-share'}>
                                        <h3>{item.navigation_name}</h3>
                                        <img
                                            src={item.home_recommend.mobileIcon}
                                        />
                                        <div className={'plan-pro-text'}>
                                            {item.yijuhua}
                                        </div>
                                        <div className={'plan-pro-more'}>
                                            了解更多
                                        </div>
                                    </div>
                                </a>;

                            })
                            : ''
                        }
                    </div>
                    {
                        planList.length > 0
                            ? <div
                                className={`linkText ${planOff ? 'on' : ''}`}
                                onClick={() => {
                                    this.setState({
                                        planOff: !planOff
                                    });
                                }}
                            >
                                {planOff ? '收起' : '查看'}全部
                            </div>
                            : ''
                    }


                </div>

                <div className={'spu-work'}>
                    <h3 className={'spu-work-title'}>
                        因为了解 所以信赖
                    </h3>
                    <img src={require('../../asset/image/home/huoban.png')} alt="" width={'100%'}/>
                </div>

                <div className={'feedback-mod'}>
                    <div className={'feedback-mod-text'}>
                        百度安全以技术开源、专利共享、标准驱动为理念，联合互联网公司、安全厂商、终端制造商、
                        高校及科研机构， 推动AI时代的安全生态建设，让全行业享受更安全的AI所带来的变革。
                    </div>
                    <img
                        src={require('../../asset/image/home/pinpai.png')}
                        alt="百度品牌"
                        width={'100%'}
                        className={'feedback-mod-img'}
                    />
                    <img
                        src={require('../../asset/image/home/image_zizhi-wap.png')}
                        alt="资质文件"
                        width={'100%'}
                        className={'feedback-mod-icon'}
                    />
                    <div className={'feedback-mod-char'}>
                        <span>CSA STAR 国际认证</span>
                        <span>信息系统安全等级保护第Ⅲ级</span>
                        <span>ISO27017 云安全管理体系认证</span>
                    </div>
                </div>

                <div className={'spu-news'}>
                    <h3>前沿领域的新观察</h3>
                    <p className={'spu-forum-des'}>
                        行业资讯、前沿技术、开源实战，新鲜，<br/>
                        有趣，实用
                    </p>
                    <div className={'spu-forum-mod'}>
                        <div className={'page-box'}>
                            {!this.isEmptyobj(articleList)
                                ? articleList.itemlist.article_list.datalist.map((item, index) => {
                                    if (index < 4) {
                                        return <a
                                            href={`/m/forum/page/${item.aid}`}
                                            className={'section'}
                                            key={index}
                                        >
                                            <ListPro
                                                title={item.title}
                                                imgSrc={item.pic}
                                                tagList={item.tags_data}
                                            />
                                        </a>;
                                    }
                                })
                                : ''
                            }
                        </div>
                    </div>
                </div>
                <div className={'user-recall'}>
                    <a href={'/m/apply'}>立即咨询</a>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        cmsapiHomepagea: state.cmsapiHomepagea,
        articleList: state.articleList
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiHomepage: () => fetchCmsapiHomepage(dispatch),
        fetchArticleList: () => fetchArticleList(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/index.js